import * as Firebase from 'firebase';

//import firestore from 'firebase/firestore'

//const settings = {timestampsInSnapshots: true};


const config = {
    apiKey: "AIzaSyCHYwUiVz2lPiQI0-XaWl5LNN9Pb-DK4Xo",
    authDomain: "precheckin-1466b.firebaseapp.com",
    databaseURL: "https://precheckin-1466b.firebaseio.com",
    projectId: "precheckin-1466b",
    storageBucket: "precheckin-1466b.appspot.com",
    messagingSenderId: "114123862069",
    appId: "1:114123862069:web:4ad2a181aa485fa4d0417c",
    measurementId: "G-M3C7K9R1T0"
  };

//Firebase.initializeApp(config);

//Firebase.firestore().settings(settings);



function initFirebase () {
  console.log("inizializzo firebase2")
  Firebase.initializeApp(config)
  console.log("inizializzata app")
  if (Firebase.messaging.isSupported()){  //Safari non supporta notifiche push
    console.log("inizializzo messaging")
    const messaging = Firebase.messaging();
    messaging.usePublicVapidKey("BEl8ejcbGUk7DzvPOO3W5UDZtVhBdpOzEIRfE6NyO3cb7UfAOhYNlTPRk_AxDu_tR9tZNECvLVBb8659EivPLMM");
  
    

  }

  // Request Permission of Notifications


  return new Promise((resolve, reject) => {
    Firebase.firestore().enablePersistence()
      .then(resolve)
      .catch(err => {
        if (err.code === 'failed-precondition') {
          reject(err)
          // Multiple tabs open, persistence can only be
          // enabled in one tab at a a time.
        } else if (err.code === 'unimplemented') {
          reject(err)
          // The current browser does not support all of
          // the features required to enable persistence
        }
      })
  })
}

//login anonimo impostato su /store/index.js


//---------------------------FCMcd
// Get Instance ID token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.

/*messaging.getToken().then((currentToken) => {
  if (currentToken) {
    sendTokenToServer(currentToken);
    updateUIForPushEnabled(currentToken);
  } else {
    // Show permission request.
    console.log('No Instance ID token available. Request permission to generate one.');
    // Show permission UI.
    updateUIForPushPermissionRequired();
    setTokenSentToServer(false);
  }
}).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
  showToken('Error retrieving Instance ID token. ', err);
  setTokenSentToServer(false);
});

// Callback fired if Instance ID token is updated.
messaging.onTokenRefresh(() => {
  messaging.getToken().then((refreshedToken) => {
    console.log('Token refreshed.');
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    setTokenSentToServer(false);
    // Send Instance ID token to app server.
    sendTokenToServer(refreshedToken);
    // ...
  }).catch((err) => {
    console.log('Unable to retrieve refreshed token ', err);
    showToken('Unable to retrieve refreshed token ', err);
  });
});
*/
export { Firebase, initFirebase }